import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";

const RemoveCarouselImg = ({
  isRemoveOpen,
  closeRemoveModal,
  deleteBannerCms,
  selectedImgUrl
}) => {

  const handleDelete = async () => {
    deleteBannerCms();
    closeRemoveModal();
  };

  return (
    <Modal
      show={isRemoveOpen}
      onHide={closeRemoveModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Remove Banner Image</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={selectedImgUrl} className="img-fluid mb-2"/>
        <div>Are you sure you want to remove this banner image?</div>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Delete" callBack={handleDelete} />
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveCarouselImg;
